export const GET_EMPLOYEES = "GET_EMPLOYEES";
export const ADD_EMPLOYEE = "ADD_EMPLOYEE";
export const EDIT_EMPLOYEE = "EDIT_EMPLOYEE";
export const GET_EMPLOYEE = "GET_EMPLOYEE";
export const RESET_EMPLOYEE = "RESET_EMPLOYEE";
export const ERROR_EMPLOYEE = "ERROR_EMPLOYEE";
export const GET_ALL_EMPLOYEES = "GET_ALL_EMPLOYEES";
                